<template>
  <div id="login">

    <div class="login-container" ref="loginContainer">
      <div class="center-parent">
        <div class="logo"></div>

        <div class="inputs">
          
          <form>

            <div class="forgot-text" :class="{toggled: forgotToggle}">Enter your email below, and we'll send you password reset instructions.</div>
            <div class="input move" :class="{toggled: forgotToggle}">
              <v-text-field 
                ref="inputEmail"
                :rules="validation.emailRules"
                :validate-on-blur="!!$refs.inputEmail && $refs.inputEmail.valid"
                box hide-details
                placeholder="email@address.com"
                type="email"
                v-model.trim="email"
                @focus="inputFocused"
                @keyup.enter="emailEnterKeyed">
              </v-text-field>
            </div>

            <div class="input hide" :class="{toggled: forgotToggle}">        
              <v-text-field
                ref="inputPassword"
                :rules="validation.passwordRules"
                :validate-on-blur="!!$refs.inputPassword && $refs.inputPassword.valid"
                box hide-details
                placeholder="password"
                type="password"
                v-model.trim="password"
                @focus="inputFocused"
                @keyup.enter="login"
                autocomplete="off"
              ></v-text-field>
            </div>
            
          </form>

          <div ref="scrollTarget"></div>
        </div>

        <div class="buttons">
          <div class="button-holder">
            <v-btn flat class="button forgot" @click="toggleForgot">{{ forgotToggle ? 'BACK TO LOGIN' : 'FORGOT PASSWORD'  }}</v-btn>
            <v-btn class="button login" :loading="loginLockout" @click="forgotToggle ? forgot() : login()">{{ forgotToggle ? 'SEND' : 'LOG IN'  }}</v-btn>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      
      </div>
      <div class="vo-scrim" :class="{active: appPrompt}"></div>
    </div>

    <transition name="app-prompt">
      <div class="mobile-prompt" v-if="appPrompt">
        <div class="logo"></div>
        <div class="text">For a better experience, please download our free <span>{{ mobile }} app.</span></div>

        <div class="app-button" v-if="mobile === 'Android'" :style="{backgroundImage: 'url(./assets/apps/play-store.png)'}" @click="openLink('android')"></div>
        <div class="app-button" v-if="mobile === 'iOS'" :style="{backgroundImage: 'url(./assets/apps/app-store.svg)'}" @click="openLink('ios')"></div>

        <div class="screenshot" v-if="mobile === 'Android'" :style="{backgroundImage: 'url(./assets/apps/phones-android.png)'}"></div>
        <div class="screenshot" v-if="mobile === 'iOS'" :style="{backgroundImage: 'url(./assets/apps/phones-ios.png)'}"></div>
        
        <div class="buttons">
          <div class="button" @click="hideAppPrompt(true)">NEVER SHOW<br>THIS AGAIN</div>
          <div class="button" @click="hideAppPrompt(false)">REMIND ME<br>LATER</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

  import permissionMixin from '../mixins/permissionMixin'

  export default {
    mixins: [permissionMixin],
    data () {
      return {
        appPrompt: false,
        email: '',
        password: '',
        loginLockout: false,
        forgotToggle: false,
        invalidEmail: false,
        invalidPassword: false,
        validation: {
          emailRules: [

            // Email Regex test
            function (e) {
              return !window.regex.email.test(e) ? 'Email or Password is incorrect' : true;
            },
            function (e) {
              if (this.invalidEmail && this.invalidPassword) {
                this.invalidEmail = false;

                return 'Email or Password is incorrect.';

              } else if (this.invalidEmail) {
                this.invalidEmail = false;

                return 'Email Not Found.';

              } else {
                return true;
              }
            }.bind(this)
          ],
          passwordRules: [

            // Password Length test
            function (e) {
              return window.regex.password.test(e);
            },
            function (e) {
              if (this.invalidPassword) {
                this.invalidPassword = false;

                return 'Email or password is incorrect.';
              } else {
                return true;
              }
            }.bind(this)
          ]
        }
      }
    },

    computed: {

      mobile () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i )) {
          return 'iOS';
        }
        else if (userAgent.match( /Android/i )) {
          return 'Android';
        }
        else {
          return false;
        }
      }

    },

    methods: {

      inputFocused () {
        setTimeout(() => {
          this.$SmoothScroll(this.$refs.scrollTarget, 300, null, this.$refs.loginContainer);
        }, 500);
      },
      
      emailEnterKeyed () {
        if (this.forgotToggle)  this.forgot();
        else                    this.login();
      },

      login () {
        this.loginLockout = true;

        this.$store.dispatch('login', {
          username: this.email,
          password: this.password
        })
        .then(data => {
          return window.AppData.firstLoad();
        })
        .then(data => {
          
          var query = null;
          if (this.$route.query.dialog && this.$route.query.dialog === 'changelog') {
            query = {
              dialog: 'changelog'
            }
          }

          this.reroute(null, query); // Open app to a page the user has access to
          this.loginLockout = false;
        })
        .catch(e => {
          
          console.log(e);

          if (e.code === ERRORS.NO_ROLES) {
            // Don't need to do anything since the function that kicks them out handles it 
          }
          else {
            window.Toast.show('Email or password is incorrect.', 'error');
            this.invalidEmail = true;
            this.invalidPassword = true;
            this.validate();
          }
        
          this.loginLockout = false;          
        });
      },

      forgot () {
        this.loginLockout = true;

        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.loginLockout = false;
          return;
        }

        this.$store.dispatch('forgotPassword', {
          email: this.email,
        })
        .then(data => {
          this.email        = this.password = '';
          this.forgotToggle = false;
          this.loginLockout = false;

          window.Dialog.showDialog({
            title: 'Recovery Email Sent', 
            body: 'Please check your email for further instructions for resetting your password.',
            dismiss: {
              title: 'Got It'
            }
          })
        })
        .catch(e => {
          console.log(e);

          if (e.error && e.error.code && e.error.code === 40009) {
            this.invalidEmail = true;
            this.validate();
          }

          window.Toast.show('Email not found.', 'error');
          this.loginLockout = false;          
        });
      },

      validate () {
        this.$refs.inputEmail.validate(true);
        var valid = this.$refs.inputEmail.valid;

        if (!this.forgotToggle) {
          this.$refs.inputPassword.validate(true);
          valid = this.$refs.inputPassword.valid;
        }

        return valid;
      },

      toggleForgot () {
        this.forgotToggle = !this.forgotToggle;

        this.$refs.inputEmail.valid = true;
        this.$refs.inputEmail.errorBucket = [];
        this.$refs.inputPassword.valid = true;
        this.$refs.inputPassword.errorBucket = [];
        this.password = '';
      },

      openLink (link) {
        window.open(window.urls.apps[link], '_blank');
      },

      hideAppPrompt (store) {
        if (store) window.localStorage.setItem('hideAppPrompt', true);
        this.appPrompt = false;
      }
    },
    
    created () {
      this.$nextTick( () => {
        this.$refs.inputEmail.valid = true;
        this.$refs.inputPassword.valid = true;
      });

      var hideAppPrompt = window.localStorage.getItem('hideAppPrompt');

      this.appPrompt = (!window.cordova && this.mobile && !hideAppPrompt);
    }
  }

</script>

<style lang="scss" scoped>

@import '../css/global.scss';
@import '../css/transitions.scss';

  #login {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $primary;
    
    .vo-scrim {
      transition: all .5s ease .3s !important;
    }

    .login-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transition: all .5s ease;
      @include scrollable();

      &.dark {
        opacity: .54;
      }
    }

    .mobile-prompt {
      background: $primary;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      overflow: hidden;

      .logo {
        background: url("../assets/logos/vilio-white.svg");
        @include backgroundCenter();
        width: 280px;
        height: 80px;
        margin: 40px auto 24px;
      }

      .text {
        color: $white;
        margin: 0 auto;
        text-align: center;
        font-size: 16px;
        width: calc(100% - 32px);
      }

      .app-button {
        @include backgroundCenter();
        width: 260px;
        height: 120px;
        margin: 0 auto 16px;
        cursor: pointer;
      }

      .screenshot {
        background-size: contain;
        background-position: top center;
        background-repeat: no-repeat;
        width: calc(100% - 100px);
        height: 500px;
        margin: 0 auto;
      }
      
      .buttons {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: $accent;
        color: $black87;
      
        .button {
          @include fontPrimary500();
          padding: 16px;
          width: 50%;
          color: $black87;
          float: left;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;
          user-select: none;
        }
      }
    }
  
    .center-parent {
      max-width: 400px;
      margin: 0 auto;
      width: calc(100% - 32px);
      min-height: 500px;

      .logo {
        width: 100%;
        max-width: 80%;
        height: 200px;
        background: url('../assets/logos/vilio-white.svg'); 
        @include backgroundCenter();
        margin: 0 auto;
      }

      .forgot-text {
        @include fontPrimary400();
        position: absolute;
        padding: 3px 0 0 0;
        box-sizing: border-box;
        margin: 8px 0 0;
        left: 8%;
        right: 8%;
        text-align: center;
        color: $white;
        opacity: 0;
        font-size: 14px;
        line-height: 20px;

        transition: all 0s ease .4s;

        &.toggled {
          opacity: 1;
          transition: all 0s ease;
        }
      }

      .input {
        position: relative;
        width: 100%;
        margin: 8px 0;
        background: $white;
        border-radius: 3px;
        overflow: hidden;

        .input-group {
          padding: 0;

          .input-group__input { 
            min-height: 20px;
          }

          .input-group--text-field-box .input-group__details {
            padding: 0 !important;
          }
        }

        &.move {
          transition: all .3s ease;
        }

        &.move.toggled {
          transform: translate3d(0, 62px, 0);
          transition: all .3s ease .15s;
        }

        &.hide {
          transition: all .3s ease .15s;
        }

        &.hide.toggled {
          opacity: 0;
          pointer-events: none;
          transition: all .3s ease;
        }

      } // .input

      .buttons {
        @include fontPrimary500();
        @include title();
        width: 100%;

        .button-holder {
          float: right;
        }

        .button {
          font-size: 14px;
          color: $black54;
          user-select: none;
          cursor: pointer;
          text-align: center;

          &:not(:first-of-type) {
            margin: 0 0 0 6px;
          }

          &.forgot {
            width: 160px;
          }

          &.login {
            color: $black87;
            background: $accent;
            box-shadow: $cardShadow(); 
          }
        }
      }
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      .center-parent {
        .input {
          position: relative;
          width: 100%;
          margin: 8px 0;
          background: $white;
          border-radius: 3px;
          overflow: hidden;

          .input-group {
            padding: 0;
            width: calc(100% - 16px);
          }
        }
      }
     
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue